import { applySeo } from "../lib/seo";
import { useEffect } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT, LOCATIONS, CONTACT_PAGE as CP } from "../data/site";
import { MaskedLines, Reveal } from "../components/site/Reveal";
import { EnquiryForm } from "../components/site/EnquiryForm";
import { ShowroomMap } from "../components/site/ShowroomMap";

export default function Contact() {
  useEffect(() => {
    applySeo({ paths: ["/contact/"], fallbackTitle: "Contact Us | Cedar Views, Chobham" });
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="contact-page" className="pt-28">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <Reveal><p className="overline-x mb-6">{CP.overline}</p></Reveal>
        <MaskedLines
          as="h1"
          lines={[CP.title]}
          delay={0.15}
          className="font-display tracking-tighter text-5xl sm:text-6xl lg:text-8xl text-white leading-[0.95]"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-16 lg:mt-24">
          <Reveal delay={0.2}>
            <h2 className="text-base md:text-lg text-white/70 font-normal leading-relaxed max-w-md">
              {CP.intro}
            </h2>
            <div className="mt-12 space-y-8">
              {[
                { icon: Phone, label: "Telephone", value: CONTACT.phone, href: CONTACT.phoneHref, tid: "contact-phone" },
                { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, tid: "contact-email" },
                ...LOCATIONS.map((l, i) => ({ icon: MapPin, label: `${l.name} · ${l.place}`, value: (l.address || []).join(", "), tid: i === 0 ? "contact-address" : `contact-address-${l.id || i}` })),
                { icon: Clock, label: "Opening hours", value: CONTACT.hours, tid: "contact-hours" },
              ].map((row) => (
                <div key={row.label} className="flex items-start gap-5 border-b hairline pb-8">
                  <row.icon size={18} className="text-white/40 mt-1" />
                  <div>
                    <p className="overline-x mb-2">{row.label}</p>
                    {row.href ? (
                      <a href={row.href} data-testid={row.tid} className="font-display text-xl text-white hover:text-white/70 transition-colors">{row.value}</a>
                    ) : (
                      <p data-testid={row.tid} className="font-display text-xl text-white">{row.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.35} className="bg-[#0B162C] p-8 lg:p-12 border hairline h-fit">
            <p className="overline-x mb-8">{CP.formTitle}</p>
            <EnquiryForm />
          </Reveal>
        </div>
      </section>

      <ShowroomMap />
    </main>
  );
}
